// removed by extract-text-webpack-plugin
module.exports = {"centered":"centered__3MSRU","videoBox":"videoBox__2qg_f","video":"video__mBZaY","videoPlayButton":"videoPlayButton__1b7JP"};


//////////////////
// WEBPACK FOOTER
// ./components/video/styles.styl
// module id = KtI6
// module chunks = 0